import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"panorama-vertical"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M4.5 2L19.5 2C19.5 2 18 7 18 12C18 17 19.5 22 19.5 22L4.5 22C4.5 22 6 17 6 12C6 7 4.5 2 4.5 2Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4.5 2L19.5 2C19.5 2 18 7 18 12C18 17 19.5 22 19.5 22L4.5 22C4.5 22 6 17 6 12C6 7 4.5 2 4.5 2Z","strokeWidth":"props.strokeWidth"}}]}]};

const PanoramaVertical = Vue.extend<IconProps>({
  name: 'PanoramaVerticalIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'panorama-vertical',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default PanoramaVertical;
